//react
import { useContext,useState ,useEffect} from 'react';
import moment from 'moment';
import { v4 as uuid } from "uuid";
//component
import { Card } from '../../../component/Card/Card';
//css
import "../index.css";
import "./createnote.css";
//context
import NoteContext from '../../../context/NoteContext';
import { useAuth } from 'my-webapp/context/login/AuthContext';
import {getLabelNote,getPriority,getdate,getSearchCart,getpin} from '../../subpages/utility/filterutility';
//draf-js
import { convertToRaw, EditorState ,ContentState} from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import { Editor } from "react-draft-wysiwyg";
import "../../../../../node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
//service
import {handle_postNote} from '../../../api/utility';


const CreateNote = ({route}) =>{
    //
    const {noteItems,handler_CreateNote,filter,toastdispatch,handle_AddTag,tagList} = useContext(NoteContext);
    let {token} = useAuth()
    //
    const [gettext,settext]=useState("")
    const [getDesc,setDesc]=useState("")
    const [getcolor,setColor]=useState("#555555")
    const [get_pin,setPined]=useState(false)
    const [getpriority,setpriority]=useState("")
    const [editorState,seteditorState] = useState(EditorState.createEmpty())
    const [rawMessage,setrawMessage]=useState("")
    const [addtag,setaddtag]=useState("")
    const[getlabel,setlabel]=useState("")
    const [getlabelList,setlabelList]=useState([])
    const[isemty,setempty]=useState(true)
    
    //function
    // const LabelNote = getLabelNote(noteItems,filter.isChecked);
    // const PriorityNote = getPriority(LabelNote,filter.priority);
    // const SortBydateNote = getdate(PriorityNote,filter.sortdate);
    // const SortBypin = getpin(SortBydateNote,filter.sortpin)
    // const SearchByTitle = getSearchCart(SortBypin,filter.search);
    //

    useEffect(()=>{
        window.scrollTo({ behavior: 'smooth', top: '0px' });
    },[])
    
    //constant 
    let note = {
        id:uuid(),
        title : gettext,
        desc : editorState,
        color : getcolor,
        pin :get_pin,
        label:getlabelList,
        priority:getpriority,
        date : moment(new Date()).format("DD/MM/YYYY HH:mm:ss")
    }

    
    const wrapperStyle = {
        // border: '1px solid #969696',
        color:'black',
        // background:"rgba(93, 62, 161, 0.3)",
    }

    const toolbarStyle={
        background:'transparent',
        border:"none"
    }

    const editorStyle = {
        height:'5rem',
        padding:'1rem',
        color:'black',
        // background:"rgba(93, 62, 161, 0.3)",
    }


    const clearnote=()=>{
        settext("")
        setColor("#555555")
        setpriority("")
        setPined(false)
        seteditorState(EditorState.createEmpty());
    }

    const onEditorStateChange =(editorState)=>{
        const content = editorState.getCurrentContent();
        const isEditorEmpty = !content.hasText();
        const currentPlainText = content.getPlainText()
        const lengthOfEditorContent = currentPlainText.length;
        const lengthOfTrimmedContent = currentPlainText.trim().length;
        const isContainOnlySpaces = !isEditorEmpty && !lengthOfTrimmedContent;
    
        if(isEditorEmpty || isContainOnlySpaces){
            
        }else{
            setempty(false)
        }
        seteditorState(draftToHtml(convertToRaw(editorState.getCurrentContent())))
    }

     const handleonsubmit=(e)=>{
        e.preventDefault(); 
        if(!isemty){
            handle_postNote(e,token,note,handler_CreateNote,toastdispatch);
            clearnote();
            localStorage.setItem("route","home");
            route()
        }else{
            alert("desc is empty")
        } 
     }

     const handleSubmitAddtag=()=>{
        //e.preventDefault(); 
        // console.log(tagList)

        if(addtag.trim()!==""){
            let check = tagList.length>0 && tagList.find(i=>i.name===addtag.trim())
            if(check){
                alert("name already added")
            }else{
                let data ={
                    id:Math.random(),
                    name:addtag.trim()
                }
                handle_AddTag(data)
                setaddtag("")
            }
        }else{
            alert("text is empty")
        }
    }

    const handleAddTagTextName=(e)=>{
        setaddtag(e.target.value.trim())
    }

    const handleAddLabelList=(e)=>{
        if(e.target.value!==""){
            setlabel(e.target.value)
            let data ={
                id:Math.random(),
                name:e.target.value
            }

            let check = getlabelList.length>0 && getlabelList.find(i=>i.name===e.target.value)
            if(check){
                    alert("already name tag")
            }else{
                    setlabelList(res=>[...res,data]) 
            }   
        }else{
            alert("select tag")
        }   
    }


    return(
        <div className='flex-col flex-justify-content-center flex-align-item-center row-gap-1rem typology-padding-top'>
            <form className="notes-form" onSubmit={(e)=>{ handleonsubmit(e) }}>
               
               <div className='notes-form-input'>
                <input type="text" placeholder='title' value={gettext} onChange={(e)=>{settext(e.target.value)}} required/>
                <div className='draft-editor'> 
                        <Editor
                            initialEditorState={editorState}
                            wrapperStyle={wrapperStyle}
                            editorStyle={editorStyle}   
                            toolbarStyle={toolbarStyle}                                                                         
                            onEditorStateChange={onEditorStateChange}
                            placeholder='add description'
                            required
                        />
                    </div>
               </div>
              

                <div className='cn-box-flex'> 
                    <div className='flex-col row-gap-1rem typology-padding-top'> 
                           <label>
                                Set Background Color :  <input type="color" value={getcolor} onChange={(e)=>{setColor(e.target.value)}} required/> 
                           </label>
                         
                           <label> 
                             Set Pined : <input type="checkbox" name="pin" value={get_pin} checked={get_pin===true} onChange={(e)=>{setPined(!get_pin)}}/>  
                           </label>

                           <div className='flex-row col-gap-1rem'>
                                <label> Set Priority : </label>
                                <label>
                                    <span> High </span>
                                    <input type="radio" name="Priority" value="High" onChange={(e)=>{setpriority(e.target.value)}} required/>
                                </label>
                                <label>
                                    <span> Medium </span>
                                    <input type="radio" name="Priority" value="Medium" onChange={(e)=>{setpriority(e.target.value)}} required/> 
                                </label>
                                <label>
                                    <span> Low </span> 
                                    <input type="radio" name="Priority" value="Low" onChange={(e)=>{setpriority(e.target.value)}} required/>  
                                </label>
                           </div>
                    </div>
                    <div className='flex-col row-gap-1rem typology-padding-top'>
                           <label> Set Tag : </label>
                           <div>
                               <div>
                                 <input className='input-tag' placeholder='add tag...' value={addtag} onChange={(e)=>{ handleAddTagTextName(e) }}/> 
                                 <span className='button-outline-primary button-onhover-fillbackground cursor' onClick={()=>{handleSubmitAddtag()}}> Add Tag </span>
                               </div>
                              <span> Select tag : </span>
                               {
                                tagList.length>0?
                                      <select value={getlabel} onChange={(e)=>handleAddLabelList(e)}>
                                        <option value="">--tag name list--</option>
                                        {tagList.map((item,index)=>{
                                            return (
                                                    <option key={index} value={item.name}> {item.name} </option>
                                            )}
                                        )}
                                      </select> 
                                      :
                                      <span> No tag in list </span>
                               }
                           </div>
                           <div>
                               {getlabelList.length>0?
                               <> 
                                  <label> This Note Tag with: </label>
                                  {
                                   getlabelList.map((item,index)=>{
                                    return(
                                    <div key={index}> 
                                        <label className='tag-name-badge'> {item.name} </label>  
                                        <span className='tag-name-badge-remove cursor' onClick={()=>{setlabelList(getlabelList.filter((_d,_di)=>_di!==index))}}> x </span> 
                                    </div>)
                                  }) 
                                  }  
                               </> 
                               :null}
                           </div>
                    </div>
                </div>

                <div className='typology-padding-top'>
                    <button className='button button-outline-primary button-onhover-fillbackground ' type='submit'> Add Note </button>
                </div>                    
            </form>
{/*             
            {SearchByTitle.length>0?<h3> PINNED </h3>:null}
                <div className='typology-padding-top grid-note-cart'>
                  {SearchByTitle.length>0 && SearchByTitle.map((item,index)=>{
                    return item.pin===true? <Card data={item}/>:null  
                  })}
                </div>
            {SearchByTitle.length>0?<h3> OTHERS </h3>:null}
            <div className='typology-padding-top grid-note-cart'>
                  {SearchByTitle.length>0 && SearchByTitle.map((item,index)=>{
                         return item.pin===false ?  <Card data={item}/> : null
            })}
            </div> */}

        </div>
    )
} 

export default CreateNote;